import { render, staticRenderFns } from "./NavigationMealsAdd.vue?vue&type=template&id=6e6066ec&scoped=true"
import script from "./NavigationMealsAdd.vue?vue&type=script&lang=js"
export * from "./NavigationMealsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6066ec",
  null
  
)

export default component.exports